<template>
    <Form @submit="createOrUpdate" :key="createMode">
        <div class="season-name-form flex flex-column overflow-hidden gap-3">

            <CustomCalendar name="year" v-model="editedSeason.year" :label="$t('message.season.year')"
                            :showTime="false" no-placeholder dateFormat="yy"
                            view="year" showButtonBar class="w-10"
                            :max-date="null" :required="true"/>

            <CustomCalendar name="startDate" v-model="editedSeason.startDate" selectionMode="single"
                            :label="$t('message.season.startDate')" class="w-10"
                            :showTime="false" no-placeholder showButtonBar
                            :max-date="null" :required="true"/>

            <CustomCalendar name="endDate" v-model="editedSeason.endDate" selectionMode="single"
                            :label="$t('message.season.endDate')" class="w-10"
                            :showTime="false" no-placeholder showButtonBar
                            :max-date="null" :required="true"/>

<!--            <CustomSelectOneYesNo name="active" v-model="editedSeason.active" class="w-10"-->
<!--                                  :label="$t('message.season.active')" no-placeholder/>-->

            <div class="season-buttons flex align-self-center gap-4 mt-6">
                <CustomButton :label="$t('message.other.save')" type="submit" />
                <CustomButton v-if="createMode" :label="$t('message.other.cancel')" secondary
                    @click="hideForm" />
                <CustomButton v-else :label="$t('message.other.delete')" secondary @click="deleteSelectedSeason"
                    :disabled="createMode" />
            </div>
        </div>
    </Form>
</template>

<script>
import {Form} from "vee-validate";
import { createOrUpdateSeason, deleteSeason } from "@/swagger/vue-api-client";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import CustomSelectOneHorseBreed from "@/components/form/CustomSelectOneHorseBreed.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox.vue";
import _ from 'lodash';
import CustomButton from "@/components/form/CustomButton.vue";
import { ValidateUtils } from "@/utils/ValidateUtils";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomCalendar from "@/components/form/CustomCalendar.vue";
import CustomSelectOneYesNo from "@/components/form/CustomSelectOneYesNo.vue";

export default {
    name: "SeasonForm",
    components: {
        CustomSelectOneYesNo,
        CustomCalendar,
        CustomCheckbox,
        CustomSelectOneHorseBreed,
        CustomInputText,
        CustomInputNumber,
        CustomButton,
        Form
    },

    props: {
        selectedSeason: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            editedSeason: {
                year: null,
                startDate: null,
                endDate: null,
                active: true
            },
            loading: false,
            createMode: true,
            showErrorMessages: false,
        };
    },

    emits: ["change-element", "createMode", "hideForm"],

    mounted() {
        this.$emit("createMode", this.createMode);
    },

    methods: {
        validateData() {
            return true;
        },
        getRequiredMessage(value) {
            if (this.showErrorMessages && (value === null || value === "")) {
                return this.$t("message.validations.required");
            }
            return "";
        },
        notifyChange() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: this.$t('message.other.success'),
                detail: this.$t('message.other.dataSaved'),
                life: 3000,
            });
        },
        notifyDelete() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: this.$t('message.other.success'),
                detail: this.$t('message.other.elementDeleted'),
                life: 3000,
            });
        },
        notifyError(error) {
            if (error.response?.data) {
                for (const [key, value] of Object.entries(error.response.data)) {
                    if (key !== "path" && key !== "status" && key !== "timestamp" && key !== 'code') {
                        this.$toast.add({
                            severity: "error",
                            summary: this.$t("message.other.error"),
                            detail: value,
                            life: 5000,
                        });
                    }
                }
            } else {
                const message = error.response?.data?.message || this.$t('unknownError');
                this.$toast.add({
                    severity: "error",
                    summary: this.$t("message.other.error"),
                    detail: message,
                    life: 5000,
                });
            }
        },
        async createOrUpdate() {
            if (this.validateData()) {
                try {
                    await createOrUpdateSeason({ body: this.editedSeason });
                    this.notifyChange();
                } catch (error) {
                    this.notifyError(error);
                }
            }
        },
        async deleteSelectedSeason() {
            try {
                await deleteSeason({ id: this.editedSeason.id });
                this.notifyDelete();
                this.showErrorMessages = false;
            } catch (error) {
                this.notifyError(error);
            }
        },
        hideForm() {
            this.$emit("hideForm");
        },
    },

    watch: {
        selectedSeason(newValue) {
            this.editedSeason = _.cloneDeep(newValue);
            this.createMode = newValue.id === null || newValue.id === undefined || isNaN(newValue.id);
            this.$emit("createMode", this.createMode);
        },
    },
};
</script>

<style lang="scss">
.season-name-form {
    .custom-input-text, .custom-input-number, .custom-input-calendar, .custom-select-one {
        padding-left: 170px;
        .custom-label {
            text-align: right;
            z-index: 999;
            position: absolute;
            transform: translateX(-100%);
            left: 160px;
        }
    }
    @media screen and (max-width: 650px) {
        align-items: end;
        .custom-input-text, .custom-input-number {
            padding-left: 70px;
            .custom-label {
                left: 60px;
            }
        }
    }
}
</style>
